"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Container = function Container(_ref) {
  var style = _ref.style,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: Object.assign({
      width: '100%',
      paddingLeft: '5%',
      paddingRight: '5%'
    }, style)
  }, children);
};

var _default = Container;
exports["default"] = _default;